/**
 * FR-11 contextual narration: maps a tool-call name to plain words -- in the
 * companion header status line and on every tool chip, running or finished.
 * A raw tool id is never shown to a person (seen live 2026-10-10: a date
 * question showed "recall" and "search_kb" as chips). Names come from the
 * backend tool registry; anything unrecognized gets no name at all.
 */

const MEMORY_TOOLS = new Set(['recall', 'search_companion_memory']);

const LEAD_TOOLS = new Set([
  'get_lead',
  'list_leads',
  'add_lead_note',
  'create_lead',
  'get_lead_notes',
  'get_lead_stats',
  'get_stats_leads',
]);

const FINANCIAL_TOOLS = new Set([
  'get_invoice',
  'list_invoices',
  'list_payments',
  'list_receipts',
  'record_payment',
  'create_invoice',
  'approve_receipt',
  'list_products',
  'list_bank_accounts',
  'list_ewallets',
  'get_accounting_stats',
  'get_stats_financials',
]);

/** Plain words for a known tool, or null: the caller then says nothing about which tool. */
export function toolLabel(name: string): string | null {
  if (MEMORY_TOOLS.has(name)) return 'Checking your notes';
  if (name === 'search_kb') return 'Searching your documents';
  if (LEAD_TOOLS.has(name)) return 'Looking through your leads';
  if (FINANCIAL_TOOLS.has(name)) return 'Checking invoices';
  return null;
}

/** What a running tool is doing, in plain words; "Working…" when the tool is not one we name. */
export function toolNarration(name: string): string {
  return `${toolLabel(name) ?? 'Working'}…`;
}
